export default "__VITE_ASSET__aSRDbi7k__"